module.exports = __webpack_public_path__ + "static/media/team-card-logo--offerpad.47eb27b3.svg";